module.exports = __webpack_public_path__ + "static/media/Stochastic.cceef143.pdf";